import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { VideoIcon, FileTextIcon, LayersIcon, MessageCircleIcon, GiftIcon, CheckIcon } from 'lucide-react';
const CORE = [{
  icon: VideoIcon,
  title: '12 sesiones individuales con Mati',
  desc: 'Una por semana, ~55 minutos. Trabajo real sobre lo que vos estás viviendo, no sobre un temario.'
}, {
  icon: FileTextIcon,
  title: 'Material semanal personalizado',
  desc: 'Documentos y ejercicios adaptados a tu proceso. No plantillas genéricas.'
}, {
  icon: LayersIcon,
  title: 'Los 5 pilares integrados',
  desc: 'Cuerpo · Mente · Identidad · Familia · Propósito, todos conectados en progresión.'
}, {
  icon: MessageCircleIcon,
  title: 'Acceso directo por WhatsApp',
  desc: 'Durante todo el programa. Para lo que aparezca en la semana, cuando aparezca.'
}];
const BONUSES = [{
  label: 'Sesión de cierre + Plan de 90 días',
  value: '$200'
}, {
  label: 'Acceso de por vida a todos los materiales',
  value: '$300'
}, {
  label: 'Mes de seguimiento post-programa por WhatsApp',
  value: '$150'
}];
export function IncludesSection() {
  return <section id="includes" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-160" data-mp="2eao4nyi0753">
      <div className="max-w-6xl mx-auto px-6" data-id="element-161" data-mp="3kkx9hza4eu7a">
        <FadeIn className="text-center mb-10 md:mb-16" data-id="element-162" data-mp="3piqkr6qa6eef">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-4" data-id="element-163" data-mp="h1vmk4kfhi6o">
            Qué incluye
          </h2>
          <p className="text-offwhite-dim text-lg" data-id="element-164" data-mp="m189sqf7or9s">
            Todo lo necesario para sostener el proceso las 12 semanas.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-165" data-mp="79ybqyxc0s8h">
          {CORE.map((item, i) => {
          const Icon = item.icon;
          return <FadeIn key={item.title} delay={i * 0.08} direction="up" className="bg-charcoal border border-charcoal-light rounded-sm p-6 md:p-8 flex gap-5" data-id="element-166" data-mp="zzorfcem426p" data-mpi={i}>
                <div className="bg-charcoal-dark p-3 rounded-sm border border-charcoal-light h-fit shrink-0" data-id="element-167" data-mp="1elccr0wjxcr5">
                  <Icon className="w-6 h-6 text-sand" data-id="element-168" data-mp="19mj1lf4qlxu5" />
                </div>
                <div data-id="element-169" data-mp="14nfu7o1abfj0">
                  <h3 className="text-lg font-heading font-bold text-offwhite mb-2 leading-snug" data-id="element-170" data-mp="14r3kmebfnlti">
                    {item.title}
                  </h3>
                  <p className="text-offwhite-dim text-sm md:text-base leading-relaxed" data-id="element-171" data-mp="vpckdoznw771">
                    {item.desc}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>

        {/* BONUSES */}
        <FadeIn delay={0.2} className="mt-8 md:mt-12" data-id="element-172" data-mp="gzohwkfqv2hq">
          <div className="bg-charcoal border border-sand/30 rounded-sm p-6 md:p-10" data-id="element-173" data-mp="h0zn8oou8iay">
            <div className="flex items-center gap-4 mb-6 md:mb-8" data-id="element-174" data-mp="cx1le684ote7">
              <div className="bg-sand/10 p-3 rounded-sm" data-id="element-175" data-mp="7z8h5iqdy9gk">
                <GiftIcon className="w-6 h-6 text-sand" data-id="element-176" data-mp="7zrx4twh6nry" />
              </div>
              <h3 className="text-xl font-heading font-bold text-offwhite" data-id="element-177" data-mp="2jlk0p9q1kodc">
                Bonos sin costo adicional
              </h3>
            </div>

            <ul className="space-y-4" data-id="element-178" data-mp="2sn0apgcy2oh1">
              {BONUSES.map(bonus => <li key={bonus.label} className="flex items-start justify-between gap-4 pb-4 border-b border-charcoal-light last:border-0 last:pb-0" data-id="element-179" data-mp="2sl75m5hzccb5">
                  <span className="flex items-start gap-3 text-offwhite-dim" data-id="element-180" data-mp="20u10fanejof0">
                    <CheckIcon className="w-5 h-5 text-sand shrink-0 mt-0.5" data-id="element-181" data-mp="24xp7ztc1ak09" />
                    {bonus.label}
                  </span>
                  <span className="font-heading font-bold text-sand shrink-0" data-id="element-182" data-mp="2emz2ffucoerj">
                    {bonus.value}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}